import { Helper } from '../Helper';
export class CallHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'DUP');
        sb.emitPushInt(node, 1);
        sb.emitOp(node, 'PICKITEM');
        sb.emitHelper(node, options, sb.helpers.cloneArray);
        sb.emitOp(node, 'DUP');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'OVER');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'PICKITEM');
        sb.emitHelper(node, options, sb.helpers.cloneArray);
        sb.emitOp(node, 'SETITEM');
        sb.emitOp(node, 'OVER');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'ARRAYSIZE');
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'NUMEQUAL');
            },
            whenTrue: () => {
                sb.emitOp(node, 'OVER');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PICKITEM');
                sb.emitOp(node, 'OVER');
                sb.emitPushInt(node, 1);
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'SETITEM');
            },
        }));
        sb.emitOp(node, 'TOALTSTACK');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'PICKITEM');
        sb.emitCall(node);
        sb.emitOp(node, 'FROMALTSTACK');
        sb.emitOp(node, 'DROP');
        sb.emitHelper(node, optionsIn, sb.helpers.handleCompletion);
    }
}

//# sourceMappingURL=CallHelper.js.map
